import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const channelBannerDetailsApi = createAsyncThunk(
    'auth/channelBanners/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.channelBannerAction("details",1,`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const channelBannerDetailsSlice = createSlice({
    name: 'channelBanner details',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetchannelBannerDetails: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(channelBannerDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(channelBannerDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(channelBannerDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetchannelBannerDetails } = channelBannerDetailsSlice.actions;
export const channelBannerDetailsReducer = channelBannerDetailsSlice.reducer